import React, { useState, useEffect } from 'react';
import { API_URL } from '../../config';
import { useAuth } from '../../hooks/useAuth';

function AdminVerifications() {
  const [verifications, setVerifications] = useState([]);
  const [statusFilter, setStatusFilter] = useState('pending');
  const [loading, setLoading] = useState(true);
  const { accessToken: token } = useAuth();

  const fetchVerifications = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/admin/verifications?status=${statusFilter}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      setVerifications(data.verifications || []);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchVerifications();
  }, [statusFilter]); // eslint-disable-line

  const reviewVerification = async (id, status) => {
    const review_note = status === 'rejected'
      ? prompt('Note de rejet (optionnel):') || ''
      : '';

    try {
      await fetch(`${API_URL}/admin/verifications/${id}/review`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ status, review_note })
      });
      fetchVerifications();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <div className="admin-page-header">
        <h2>Certifications</h2>
        <p>Demandes de verification agent/promoteur</p>
      </div>

      <div className="admin-toolbar">
        <select
          className="admin-filter"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="pending">En attente</option>
          <option value="approved">Approuvees</option>
          <option value="rejected">Rejetees</option>
        </select>
      </div>

      {loading ? (
        <div style={{padding: '2rem', textAlign: 'center', color: 'var(--text-light)'}}>
          Chargement...
        </div>
      ) : verifications.length === 0 ? (
        <div className="glass-card" style={{padding: '2rem', textAlign: 'center', color: 'var(--text-light)'}}>
          {statusFilter === 'pending'
            ? 'Aucune demande en attente'
            : `Aucune demande ${statusFilter === 'approved' ? 'approuvee' : 'rejetee'}`}
        </div>
      ) : (
        <div className="verif-cards">
          {verifications.map(v => (
            <div className="glass-card verif-card" key={v.id}>
              <div className="verif-card-header">
                <div>
                  <strong style={{color: 'var(--text)'}}>{v.nom} {v.prenom}</strong>
                  <span className={`badge badge-${v.type === 'agent' ? 'agent' : 'verified'}`} style={{marginLeft: '0.5rem'}}>
                    {v.type}
                  </span>
                </div>
                <span className={`badge badge-${v.status}`}>{v.status}</span>
              </div>

              <div className="verif-card-info">
                <p>📧 {v.email}</p>
                {v.telephone && <p>📱 {v.telephone}</p>}
                {v.documents_url && (
                  <p>📄 <a href={v.documents_url} target="_blank" rel="noopener noreferrer" style={{color: 'var(--primary)'}}>
                    Voir documents
                  </a></p>
                )}
                <p style={{fontSize: '0.75rem', color: 'var(--text-lighter, #999)'}}>
                  Demande le {new Date(v.created_at).toLocaleDateString('fr-FR')}
                </p>
              </div>

              {v.status === 'pending' && (
                <div className="verif-card-actions">
                  <button
                    className="btn-action approve"
                    onClick={() => reviewVerification(v.id, 'approved')}
                  >
                    ✅ Approuver
                  </button>
                  <button
                    className="btn-action reject"
                    onClick={() => reviewVerification(v.id, 'rejected')}
                  >
                    ❌ Rejeter
                  </button>
                </div>
              )}

              {v.review_note && (
                <div style={{marginTop: '0.5rem', fontSize: '0.8rem', fontStyle: 'italic', color: 'var(--text-light)'}}>
                  Note: {v.review_note}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AdminVerifications;
